/* Oct 14 2026 — hide the Shopify Inbox chat launcher while a size guide, drawer or other
   modal is open, and bring it back when the modal closes. On phones it also fades the
   launcher while it would cover the cart subtotal, checkout or quantity
   steppers. Leaves the chat alone once a shopper has opened it. Pairs with the .cyra-modal-open rules in layout/theme.liquid. */
(function () {
  var root = document.documentElement;
  var SELECTORS = [
    '.cyra-size-modal.open',
    'm-cart-drawer.m-cart-drawer--active',
    'dialog[open]',
    '[role="dialog"][aria-modal="true"]',
    '.pswp--open',
    '.m-drawer--active',
    '.m-modal--active'
  ].join(',');

  function isShown(el) {
    if (el.closest('shopify-chat')) return false;
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function anyModalOpen() {
    if (root.classList.contains('prevent-scroll')) return true;
    var list = document.querySelectorAll(SELECTORS);
    for (var i = 0; i < list.length; i++) {
      if (isShown(list[i])) return true;
    }
    return false;
  }

  /* Phone layouts only: fade the launcher while it would sit on top of key purchase
     information or controls (cart subtotal, checkout, quantity steppers). The sticky
     purchase bar is handled separately: cyra-mobile-fixes.css lifts the launcher above it. */
  var KEEP_CLEAR = [
    '[data-cart-subtotal]',
    '.m-cart__subtotal',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.m-cart__footer button',
    'm-quantity-input',
    '.cyra-qty'
  ].join(',');
  var mql = window.matchMedia('(max-width: 749px)');
  var launcher = null;
  var lastTry = 0;
  function launcherRect() {
    if (launcher) return launcher;
    var host = document.querySelector('shopify-chat');
    if (!host || host.hasAttribute('open') || root.classList.contains('cyra-chat-clear')) return null;
    var now = Date.now();
    if (now - lastTry < 500) return null;
    lastTry = now;
    var w = window.innerWidth, h = window.innerHeight, minX = w, minY = h, maxX = -1, maxY = -1;
    for (var y = h - 220; y < h; y += 8) {
      for (var x = Math.max(0, w - 240); x < w; x += 8) {
        var el = document.elementFromPoint(x, y);
        if (el && el.tagName === 'SHOPIFY-CHAT') {
          if (x < minX) minX = x; if (y < minY) minY = y; if (x > maxX) maxX = x; if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    /* Stored relative to the viewport bottom, where the launcher is anchored. */
    launcher = { left: minX - 8, right: maxX + 8, fromBottomTop: h - (minY - 8), fromBottomBottom: h - (maxY + 8) };
    return launcher;
  }
  function overlapsKeyControls() {
    if (!mql.matches) return false;
    var l = launcherRect();
    if (!l) return false;
    var h = window.innerHeight;
    var r = { left: l.left, right: l.right, top: h - l.fromBottomTop, bottom: h - l.fromBottomBottom };
    var els = document.querySelectorAll(KEEP_CLEAR);
    for (var i = 0; i < els.length; i++) {
      if (!els[i].offsetParent && els[i].getClientRects().length === 0) continue;
      var b = els[i].getBoundingClientRect();
      if (b.width && b.height && b.left < r.right && b.right > r.left && b.top < r.bottom && b.bottom > r.top) return true;
    }
    return false;
  }

  var queued = false;
  var lastSticky = null;
  function sync() {
    queued = false;
    var sticky = root.classList.contains('cyra-sticky-on');
    if (sticky !== lastSticky) { launcher = null; lastTry = 0; lastSticky = sticky; }
    var modal = anyModalOpen();
    var clear = !modal && overlapsKeyControls();
    root.classList.toggle('cyra-modal-open', modal);
    root.classList.toggle('cyra-chat-clear', clear);
    /* The launcher's own button can override inherited visibility, so it is faded with CSS
       and taken out of the Tab order here with inert while it is hidden. */
    var hideAny = modal || clear;
    var chats = document.querySelectorAll('shopify-chat');
    for (var i = 0; i < chats.length; i++) {
      var c = chats[i];
      var hide = hideAny && !c.hasAttribute('open');
      if (hide && !c.hasAttribute('inert')) { c.setAttribute('inert', ''); c.setAttribute('data-cyra-inert', ''); }
      if (!hide && c.hasAttribute('data-cyra-inert')) { c.removeAttribute('inert'); c.removeAttribute('data-cyra-inert'); }
    }
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(sync);
  }

  function start() {
    if (!document.getElementById('cyra-chat-guard-fade')) {
      var st = document.createElement('style');
      st.id = 'cyra-chat-guard-fade';
      st.textContent = 'html.cyra-modal-open shopify-chat:not([open]),html.cyra-chat-clear shopify-chat:not([open]){opacity:0 !important;pointer-events:none !important;transition:opacity .15s}' +
        /* Mobile cart: the back-to-top button sits on the subtotal; the page is short enough without it. */
        '@media (max-width:749px){html[data-template="cart"] #scroll-to-top-button{display:none !important}}';
      document.head.appendChild(st);
    }
    new MutationObserver(queue).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-modal', 'hidden', 'shell-ready']
    });
    new MutationObserver(queue).observe(root, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('transitionend', queue, true);
    window.addEventListener('scroll', queue, { passive: true });
    var lastW = window.innerWidth;
    /* Phone browsers resize the viewport height as the address bar hides; only a width
       change moves the launcher enough to re-measure. */
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastW) { lastW = window.innerWidth; launcher = null; lastTry = 0; }
      queue();
    }, { passive: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTimeout(queue, 50); });
    sync();
    /* The launcher is drawn by Shopify's chat script after load; check again once it has had time. */
    setTimeout(queue, 1500);
    setTimeout(queue, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
